// 2021-08
import { S1_CW2108_TestA_211115 } from './sheets/2021_08/S1-CW2108-TestA_211115'
import { S2_CW2108_TestA_211123 } from './sheets/2021_08/S2-CW2108-TestA_211123'
import { S3_CW2108_TestA_211123 } from './sheets/2021_08/S3-CW2108-TestA_211123'
import { S4_CW2108_TestA_211123 } from './sheets/2021_08/S4-CW2108-TestA_211123'
import { S5_CW2108_TestA_2111123 } from './sheets/2021_08/S5-CW2108-TestA_2111123'
import { S6_CW2108_TestA_2111123 } from './sheets/2021_08/S6-CW2108-TestA_2111123'
// 2022-03
import { S1_CW2103_TestA_211115 } from './sheets/2022_03/S1-CW2103-TestA_211115'
import { S2_CW2203_TestA_211123 } from './sheets/2022_03/S2-CW2203-TestA_211123'
import { S3_CW2203_TestA_211123 } from './sheets/2022_03/S3-CW2203-TestA_211123'
import { S4_CW2203_TestA_211123 } from './sheets/2022_03/S4-CW2203-TestA_211123'
import { S5_CW2203_TestA_2111123 } from './sheets/2022_03/S5-CW2203-TestA_2111123'
import { S6_CW2203_TestA_2111123 } from './sheets/2022_03/S6-CW2203-TestA_2111123'
// 2022-06
import { S1_CC2206_Test_NT_210507 } from './sheets/2022_06/S1-CC2206-Test-NT_210507'
// 2022-08
import { S1_CC2208_Test_NT_210507 } from './sheets/2022_08/S1-CC2208-Test-NT_210507'
import { S1_CW2208_TestA_211115 } from './sheets/2022_08/S1-CW2208-TestA_211115'
import { S2_CW2208_TestA_211123 } from './sheets/2022_08/S2-CW2208-TestA_211123'
import { S3_CW2208_TestA_211123 } from './sheets/2022_08/S3-CW2208-TestA_211123'
import { S4_CW2208_TestA_211123 } from './sheets/2022_08/S4-CW2208-TestA_211123'
import { S5_CW2208_TestA_2111123 } from './sheets/2022_08/S5-CW2208-TestA_2111123'
import { S6_CW2208_TestA_2111123 } from './sheets/2022_08/S6-CW2208-TestA_2111123'
// 2023-03
import { S1_CW2303_TestA_211115 } from './sheets/2023_03/S1-CW2303-TestA_211115'
import { S2_CW2303_TestA_211123 } from './sheets/2023_03/S2-CW2303-TestA_211123'
import { S3_CW2303_TestA_211123 } from './sheets/2023_03/S3-CW2303-TestA_211123'
import { S4_CW2303_TestA_211123 } from './sheets/2023_03/S4-CW2303-TestA_211123'
import { S5_CW2303_TestA_2111123 } from './sheets/2023_03/S5-CW2303-TestA_2111123'
import { S6_CW2303_TestA_2111123 } from './sheets/2023_03/S6-CW2303-TestA_2111123'
// 2023-08
import { S1_CC2308_Test_NT_210507 } from './sheets/2023_08/S1-CC2308-Test-NT_210507'
import { S1_CW2308_TestA_211115 } from './sheets/2023_08/S1-CW2308-TestA_211115'
import { S2_CW2308_TestA_211123 } from './sheets/2023_08/S2-CW2308-TestA_211123'
import { S3_CW2308_TestA_211123 } from './sheets/2023_08/S3-CW2308-TestA_211123'
import { S4_CW2308_TestA_211123 } from './sheets/2023_08/S4-CW2308-TestA_211123'
import { S5_CW2308_TestA_2111123 } from './sheets/2023_08/S5-CW2308-TestA_2111123'
import { S6_CW2308_TestA_2111123 } from './sheets/2023_08/S6-CW2308-TestA_2111123'
// 2024-03
import { S1_CW2403_TestA_211115 } from './sheets/2024_03/S1-CW2403-TestA_211115'
import { S2_CW2403_TestA_211123 } from './sheets/2024_03/S2-CW2403-TestA_211123'
import { S3_CW2403_TestA_211123 } from './sheets/2024_03/S3-CW2403-TestA_211123'
import { S4_CW2403_TestA_211123 } from './sheets/2024_03/S4-CW2403-TestA_211123'
import { S5_CW2403_TestA_2111123 } from './sheets/2024_03/S5-CW2403-TestA_2111123'
import { S6_CW2403_TestA_2111123 } from './sheets/2024_03/S6-CW2403-TestA_2111123'
// 2024-08
import { S1_CC2408_Test_NT_210507 } from './sheets/2024_08/S1-CC2408-Test-NT_210507'
import { S1_CW2408_TestA_211115 } from './sheets/2024_08/S1-CW2408-TestA_211115'
import { S2_CW2408_TestA_211123 } from './sheets/2024_08/S2-CW2408-TestA_211123'
import { S3_CW2408_TestA_211123 } from './sheets/2024_08/S3-CW2408-TestA_211123'
import { S4_CW2408_TestA_211123 } from './sheets/2024_08/S4-CW2408-TestA_211123'
import { S5_CW2408_TestA_2111123 } from './sheets/2024_08/S5-CW2408-TestA_2111123'
import { S6_CW2408_TestA_2111123 } from './sheets/2024_08/S6-CW2408-TestA_2111123'
// 2025-03
import { S1_CW2503_TestA_211115 } from './sheets/2025_03/S1-CW2503-TestA_211115'
import { S2_CW2503_TestA_211123 } from './sheets/2025_03/S2-CW2503-TestA_211123'
import { S3_CW2503_TestA_211123 } from './sheets/2025_03/S3-CW2503-TestA_211123'
import { S4_CW2503_TestA_211123 } from './sheets/2025_03/S4-CW2503-TestA_211123'
import { S5_CW2503_TestA_2111123 } from './sheets/2025_03/S5-CW2503-TestA_2111123'
import { S6_CW2503_TestA_2111123 } from './sheets/2025_03/S6-CW2503-TestA_2111123'
// 2025-08
import { S1_CW2508_TestA_211115 } from './sheets/2025_08/S1-CW2508-TestA_211115'
import { S2_CW2508_TestA_211123 } from './sheets/2025_08/S2-CW2508-TestA_211123'
import { S3_CW2508_TestA_211123 } from './sheets/2025_08/S3-CW2508-TestA_211123'
import { S4_CW2508_TestA_211123 } from './sheets/2025_08/S4-CW2508-TestA_211123'
import { S5_CW2508_TestA_2111123 } from './sheets/2025_08/S5-CW2508-TestA_2111123'
import { S6_CW2508_TestA_2111123 } from './sheets/2025_08/S6-CW2508-TestA_2111123'
// 2026-03
import { S1_CW2603_TestA_211115 } from './sheets/2026_03/S1-CW2603-TestA_211115'
import { S2_CW2603_TestA_211123 } from './sheets/2026_03/S2-CW2603-TestA_211123'
import { S3_CW2603_TestA_211123 } from './sheets/2026_03/S3-CW2603-TestA_211123'
import { S4_CW2603_TestA_211123 } from './sheets/2026_03/S4-CW2603-TestA_211123'
import { S5_CW2603_TestA_2111123 } from './sheets/2026_03/S5-CW2603-TestA_2111123'
import { S6_CW2603_TestA_2111123 } from './sheets/2026_03/S6-CW2603-TestA_2111123'

export interface QRInfo {
  // QR画像の横に印刷されている確認用の数字
  checkDigit: number

  // 補正サイズ
  correctSize: { w: number; h: number }
  // 補正マーカー
  correctMarkers: {
    bl: { x: number; y: number }
    br: { x: number; y: number }
    tl: { x: number; y: number }
    tr: { x: number; y: number }
  }
  asGray: boolean
  disableWhitebarance: boolean
  rotateQrPos: {
    x: number
    y: number
  } | null
  // チェック用の数値の場所
  numCheckPosition: {
    l: number
    t: number
    w: number
    h: number
  }
  clipScale?: number
  // 横向きの答案用紙ならtrue
  isHorizontal: boolean
}

export const QR_MAP = new Map<string, QRInfo>([
  // 2021-08
  [
    S1_CW2108_TestA_211115.FRONT.EXAM_GROUP_KEY,
    S1_CW2108_TestA_211115.FRONT.QR_INFO
  ],
  [
    S1_CW2108_TestA_211115.REVERSE.EXAM_GROUP_KEY,
    S1_CW2108_TestA_211115.REVERSE.QR_INFO
  ],
  [
    S2_CW2108_TestA_211123.FRONT.EXAM_GROUP_KEY,
    S2_CW2108_TestA_211123.FRONT.QR_INFO
  ],
  [
    S2_CW2108_TestA_211123.REVERSE.EXAM_GROUP_KEY,
    S2_CW2108_TestA_211123.REVERSE.QR_INFO
  ],
  [
    S3_CW2108_TestA_211123.FRONT.EXAM_GROUP_KEY,
    S3_CW2108_TestA_211123.FRONT.QR_INFO
  ],
  [
    S3_CW2108_TestA_211123.REVERSE.EXAM_GROUP_KEY,
    S3_CW2108_TestA_211123.REVERSE.QR_INFO
  ],
  [
    S4_CW2108_TestA_211123.FRONT.EXAM_GROUP_KEY,
    S4_CW2108_TestA_211123.FRONT.QR_INFO
  ],
  [
    S4_CW2108_TestA_211123.REVERSE.EXAM_GROUP_KEY,
    S4_CW2108_TestA_211123.REVERSE.QR_INFO
  ],
  [
    S5_CW2108_TestA_2111123.FRONT.EXAM_GROUP_KEY,
    S5_CW2108_TestA_2111123.FRONT.QR_INFO
  ],
  [
    S5_CW2108_TestA_2111123.REVERSE.EXAM_GROUP_KEY,
    S5_CW2108_TestA_2111123.REVERSE.QR_INFO
  ],
  [
    S6_CW2108_TestA_2111123.FRONT.EXAM_GROUP_KEY,
    S6_CW2108_TestA_2111123.FRONT.QR_INFO
  ],
  [
    S6_CW2108_TestA_2111123.REVERSE.EXAM_GROUP_KEY,
    S6_CW2108_TestA_2111123.REVERSE.QR_INFO
  ],
  // 2022-03
  [
    S1_CW2103_TestA_211115.FRONT.EXAM_GROUP_KEY,
    S1_CW2103_TestA_211115.FRONT.QR_INFO
  ],
  [
    S1_CW2103_TestA_211115.REVERSE.EXAM_GROUP_KEY,
    S1_CW2103_TestA_211115.REVERSE.QR_INFO
  ],
  [
    S2_CW2203_TestA_211123.FRONT.EXAM_GROUP_KEY,
    S2_CW2203_TestA_211123.FRONT.QR_INFO
  ],
  [
    S2_CW2203_TestA_211123.REVERSE.EXAM_GROUP_KEY,
    S2_CW2203_TestA_211123.REVERSE.QR_INFO
  ],
  [
    S3_CW2203_TestA_211123.FRONT.EXAM_GROUP_KEY,
    S3_CW2203_TestA_211123.FRONT.QR_INFO
  ],
  [
    S3_CW2203_TestA_211123.REVERSE.EXAM_GROUP_KEY,
    S3_CW2203_TestA_211123.REVERSE.QR_INFO
  ],
  [
    S4_CW2203_TestA_211123.FRONT.EXAM_GROUP_KEY,
    S4_CW2203_TestA_211123.FRONT.QR_INFO
  ],
  [
    S4_CW2203_TestA_211123.REVERSE.EXAM_GROUP_KEY,
    S4_CW2203_TestA_211123.REVERSE.QR_INFO
  ],
  [
    S5_CW2203_TestA_2111123.FRONT.EXAM_GROUP_KEY,
    S5_CW2203_TestA_2111123.FRONT.QR_INFO
  ],
  [
    S5_CW2203_TestA_2111123.REVERSE.EXAM_GROUP_KEY,
    S5_CW2203_TestA_2111123.REVERSE.QR_INFO
  ],
  [
    S6_CW2203_TestA_2111123.FRONT.EXAM_GROUP_KEY,
    S6_CW2203_TestA_2111123.FRONT.QR_INFO
  ],
  [
    S6_CW2203_TestA_2111123.REVERSE.EXAM_GROUP_KEY,
    S6_CW2203_TestA_2111123.REVERSE.QR_INFO
  ],
  // 2022-06
  [
    S1_CC2206_Test_NT_210507.FRONT.EXAM_GROUP_KEY,
    S1_CC2206_Test_NT_210507.FRONT.QR_INFO
  ],
  // 2022-08
  [
    S1_CC2208_Test_NT_210507.FRONT.EXAM_GROUP_KEY,
    S1_CC2208_Test_NT_210507.FRONT.QR_INFO
  ],
  [
    S1_CC2208_Test_NT_210507.REVERSE.EXAM_GROUP_KEY,
    S1_CC2208_Test_NT_210507.REVERSE.QR_INFO
  ],
  [
    S1_CW2208_TestA_211115.FRONT.EXAM_GROUP_KEY,
    S1_CW2208_TestA_211115.FRONT.QR_INFO
  ],
  [
    S1_CW2208_TestA_211115.REVERSE.EXAM_GROUP_KEY,
    S1_CW2208_TestA_211115.REVERSE.QR_INFO
  ],
  [
    S2_CW2208_TestA_211123.FRONT.EXAM_GROUP_KEY,
    S2_CW2208_TestA_211123.FRONT.QR_INFO
  ],
  [
    S2_CW2208_TestA_211123.REVERSE.EXAM_GROUP_KEY,
    S2_CW2208_TestA_211123.REVERSE.QR_INFO
  ],
  [
    S3_CW2208_TestA_211123.FRONT.EXAM_GROUP_KEY,
    S3_CW2208_TestA_211123.FRONT.QR_INFO
  ],
  [
    S3_CW2208_TestA_211123.REVERSE.EXAM_GROUP_KEY,
    S3_CW2208_TestA_211123.REVERSE.QR_INFO
  ],
  [
    S4_CW2208_TestA_211123.FRONT.EXAM_GROUP_KEY,
    S4_CW2208_TestA_211123.FRONT.QR_INFO
  ],
  [
    S4_CW2208_TestA_211123.REVERSE.EXAM_GROUP_KEY,
    S4_CW2208_TestA_211123.REVERSE.QR_INFO
  ],
  [
    S5_CW2208_TestA_2111123.FRONT.EXAM_GROUP_KEY,
    S5_CW2208_TestA_2111123.FRONT.QR_INFO
  ],
  [
    S5_CW2208_TestA_2111123.REVERSE.EXAM_GROUP_KEY,
    S5_CW2208_TestA_2111123.REVERSE.QR_INFO
  ],
  [
    S6_CW2208_TestA_2111123.FRONT.EXAM_GROUP_KEY,
    S6_CW2208_TestA_2111123.FRONT.QR_INFO
  ],
  [
    S6_CW2208_TestA_2111123.REVERSE.EXAM_GROUP_KEY,
    S6_CW2208_TestA_2111123.REVERSE.QR_INFO
  ],
  // 2023-03
  [
    S1_CW2303_TestA_211115.FRONT.EXAM_GROUP_KEY,
    S1_CW2303_TestA_211115.FRONT.QR_INFO
  ],
  [
    S1_CW2303_TestA_211115.REVERSE.EXAM_GROUP_KEY,
    S1_CW2303_TestA_211115.REVERSE.QR_INFO
  ],
  [
    S2_CW2303_TestA_211123.FRONT.EXAM_GROUP_KEY,
    S2_CW2303_TestA_211123.FRONT.QR_INFO
  ],
  [
    S2_CW2303_TestA_211123.REVERSE.EXAM_GROUP_KEY,
    S2_CW2303_TestA_211123.REVERSE.QR_INFO
  ],
  [
    S3_CW2303_TestA_211123.FRONT.EXAM_GROUP_KEY,
    S3_CW2303_TestA_211123.FRONT.QR_INFO
  ],
  [
    S3_CW2303_TestA_211123.REVERSE.EXAM_GROUP_KEY,
    S3_CW2303_TestA_211123.REVERSE.QR_INFO
  ],
  [
    S4_CW2303_TestA_211123.FRONT.EXAM_GROUP_KEY,
    S4_CW2303_TestA_211123.FRONT.QR_INFO
  ],
  [
    S4_CW2303_TestA_211123.REVERSE.EXAM_GROUP_KEY,
    S4_CW2303_TestA_211123.REVERSE.QR_INFO
  ],
  [
    S5_CW2303_TestA_2111123.FRONT.EXAM_GROUP_KEY,
    S5_CW2303_TestA_2111123.FRONT.QR_INFO
  ],
  [
    S5_CW2303_TestA_2111123.REVERSE.EXAM_GROUP_KEY,
    S5_CW2303_TestA_2111123.REVERSE.QR_INFO
  ],
  [
    S6_CW2303_TestA_2111123.FRONT.EXAM_GROUP_KEY,
    S6_CW2303_TestA_2111123.FRONT.QR_INFO
  ],
  [
    S6_CW2303_TestA_2111123.REVERSE.EXAM_GROUP_KEY,
    S6_CW2303_TestA_2111123.REVERSE.QR_INFO
  ],
  // 2023-08
  [
    S1_CC2308_Test_NT_210507.FRONT.EXAM_GROUP_KEY,
    S1_CC2308_Test_NT_210507.FRONT.QR_INFO
  ],
  [
    S1_CC2308_Test_NT_210507.REVERSE.EXAM_GROUP_KEY,
    S1_CC2308_Test_NT_210507.REVERSE.QR_INFO
  ],
  [
    S1_CW2308_TestA_211115.FRONT.EXAM_GROUP_KEY,
    S1_CW2308_TestA_211115.FRONT.QR_INFO
  ],
  [
    S1_CW2308_TestA_211115.REVERSE.EXAM_GROUP_KEY,
    S1_CW2308_TestA_211115.REVERSE.QR_INFO
  ],
  [
    S2_CW2308_TestA_211123.FRONT.EXAM_GROUP_KEY,
    S2_CW2308_TestA_211123.FRONT.QR_INFO
  ],
  [
    S2_CW2308_TestA_211123.REVERSE.EXAM_GROUP_KEY,
    S2_CW2308_TestA_211123.REVERSE.QR_INFO
  ],
  [
    S3_CW2308_TestA_211123.FRONT.EXAM_GROUP_KEY,
    S3_CW2308_TestA_211123.FRONT.QR_INFO
  ],
  [
    S3_CW2308_TestA_211123.REVERSE.EXAM_GROUP_KEY,
    S3_CW2308_TestA_211123.REVERSE.QR_INFO
  ],
  [
    S4_CW2308_TestA_211123.FRONT.EXAM_GROUP_KEY,
    S4_CW2308_TestA_211123.FRONT.QR_INFO
  ],
  [
    S4_CW2308_TestA_211123.REVERSE.EXAM_GROUP_KEY,
    S4_CW2308_TestA_211123.REVERSE.QR_INFO
  ],
  [
    S5_CW2308_TestA_2111123.FRONT.EXAM_GROUP_KEY,
    S5_CW2308_TestA_2111123.FRONT.QR_INFO
  ],
  [
    S5_CW2308_TestA_2111123.REVERSE.EXAM_GROUP_KEY,
    S5_CW2308_TestA_2111123.REVERSE.QR_INFO
  ],
  [
    S6_CW2308_TestA_2111123.FRONT.EXAM_GROUP_KEY,
    S6_CW2308_TestA_2111123.FRONT.QR_INFO
  ],
  [
    S6_CW2308_TestA_2111123.REVERSE.EXAM_GROUP_KEY,
    S6_CW2308_TestA_2111123.REVERSE.QR_INFO
  ],
  // 2023-03
  [
    S1_CW2403_TestA_211115.FRONT.EXAM_GROUP_KEY,
    S1_CW2403_TestA_211115.FRONT.QR_INFO
  ],
  [
    S1_CW2403_TestA_211115.REVERSE.EXAM_GROUP_KEY,
    S1_CW2403_TestA_211115.REVERSE.QR_INFO
  ],
  [
    S2_CW2403_TestA_211123.FRONT.EXAM_GROUP_KEY,
    S2_CW2403_TestA_211123.FRONT.QR_INFO
  ],
  [
    S2_CW2403_TestA_211123.REVERSE.EXAM_GROUP_KEY,
    S2_CW2403_TestA_211123.REVERSE.QR_INFO
  ],
  [
    S3_CW2403_TestA_211123.FRONT.EXAM_GROUP_KEY,
    S3_CW2403_TestA_211123.FRONT.QR_INFO
  ],
  [
    S3_CW2403_TestA_211123.REVERSE.EXAM_GROUP_KEY,
    S3_CW2403_TestA_211123.REVERSE.QR_INFO
  ],
  [
    S4_CW2403_TestA_211123.FRONT.EXAM_GROUP_KEY,
    S4_CW2403_TestA_211123.FRONT.QR_INFO
  ],
  [
    S4_CW2403_TestA_211123.REVERSE.EXAM_GROUP_KEY,
    S4_CW2403_TestA_211123.REVERSE.QR_INFO
  ],
  [
    S5_CW2403_TestA_2111123.FRONT.EXAM_GROUP_KEY,
    S5_CW2403_TestA_2111123.FRONT.QR_INFO
  ],
  [
    S5_CW2403_TestA_2111123.REVERSE.EXAM_GROUP_KEY,
    S5_CW2403_TestA_2111123.REVERSE.QR_INFO
  ],
  [
    S6_CW2403_TestA_2111123.FRONT.EXAM_GROUP_KEY,
    S6_CW2403_TestA_2111123.FRONT.QR_INFO
  ],
  [
    S6_CW2403_TestA_2111123.REVERSE.EXAM_GROUP_KEY,
    S6_CW2403_TestA_2111123.REVERSE.QR_INFO
  ],
  // 2024-08
  [
    S1_CC2408_Test_NT_210507.FRONT.EXAM_GROUP_KEY,
    S1_CC2408_Test_NT_210507.FRONT.QR_INFO
  ],
  [
    S1_CC2408_Test_NT_210507.REVERSE.EXAM_GROUP_KEY,
    S1_CC2408_Test_NT_210507.REVERSE.QR_INFO
  ],
  [
    S1_CW2408_TestA_211115.FRONT.EXAM_GROUP_KEY,
    S1_CW2408_TestA_211115.FRONT.QR_INFO
  ],
  [
    S1_CW2408_TestA_211115.REVERSE.EXAM_GROUP_KEY,
    S1_CW2408_TestA_211115.REVERSE.QR_INFO
  ],
  [
    S2_CW2408_TestA_211123.FRONT.EXAM_GROUP_KEY,
    S2_CW2408_TestA_211123.FRONT.QR_INFO
  ],
  [
    S2_CW2408_TestA_211123.REVERSE.EXAM_GROUP_KEY,
    S2_CW2408_TestA_211123.REVERSE.QR_INFO
  ],
  [
    S3_CW2408_TestA_211123.FRONT.EXAM_GROUP_KEY,
    S3_CW2408_TestA_211123.FRONT.QR_INFO
  ],
  [
    S3_CW2408_TestA_211123.REVERSE.EXAM_GROUP_KEY,
    S3_CW2408_TestA_211123.REVERSE.QR_INFO
  ],
  [
    S4_CW2408_TestA_211123.FRONT.EXAM_GROUP_KEY,
    S4_CW2408_TestA_211123.FRONT.QR_INFO
  ],
  [
    S4_CW2408_TestA_211123.REVERSE.EXAM_GROUP_KEY,
    S4_CW2408_TestA_211123.REVERSE.QR_INFO
  ],
  [
    S5_CW2408_TestA_2111123.FRONT.EXAM_GROUP_KEY,
    S5_CW2408_TestA_2111123.FRONT.QR_INFO
  ],
  [
    S5_CW2408_TestA_2111123.REVERSE.EXAM_GROUP_KEY,
    S5_CW2408_TestA_2111123.REVERSE.QR_INFO
  ],
  [
    S6_CW2408_TestA_2111123.FRONT.EXAM_GROUP_KEY,
    S6_CW2408_TestA_2111123.FRONT.QR_INFO
  ],
  [
    S6_CW2408_TestA_2111123.REVERSE.EXAM_GROUP_KEY,
    S6_CW2408_TestA_2111123.REVERSE.QR_INFO
  ],
  // 2025-03
  [
    S1_CW2503_TestA_211115.FRONT.EXAM_GROUP_KEY,
    S1_CW2503_TestA_211115.FRONT.QR_INFO
  ],
  [
    S1_CW2503_TestA_211115.REVERSE.EXAM_GROUP_KEY,
    S1_CW2503_TestA_211115.REVERSE.QR_INFO
  ],
  [
    S2_CW2503_TestA_211123.FRONT.EXAM_GROUP_KEY,
    S2_CW2503_TestA_211123.FRONT.QR_INFO
  ],
  [
    S2_CW2503_TestA_211123.REVERSE.EXAM_GROUP_KEY,
    S2_CW2503_TestA_211123.REVERSE.QR_INFO
  ],
  [
    S3_CW2503_TestA_211123.FRONT.EXAM_GROUP_KEY,
    S3_CW2503_TestA_211123.FRONT.QR_INFO
  ],
  [
    S3_CW2503_TestA_211123.REVERSE.EXAM_GROUP_KEY,
    S3_CW2503_TestA_211123.REVERSE.QR_INFO
  ],
  [
    S4_CW2503_TestA_211123.FRONT.EXAM_GROUP_KEY,
    S4_CW2503_TestA_211123.FRONT.QR_INFO
  ],
  [
    S4_CW2503_TestA_211123.REVERSE.EXAM_GROUP_KEY,
    S4_CW2503_TestA_211123.REVERSE.QR_INFO
  ],
  [
    S5_CW2503_TestA_2111123.FRONT.EXAM_GROUP_KEY,
    S5_CW2503_TestA_2111123.FRONT.QR_INFO
  ],
  [
    S5_CW2503_TestA_2111123.REVERSE.EXAM_GROUP_KEY,
    S5_CW2503_TestA_2111123.REVERSE.QR_INFO
  ],
  [
    S6_CW2503_TestA_2111123.FRONT.EXAM_GROUP_KEY,
    S6_CW2503_TestA_2111123.FRONT.QR_INFO
  ],
  [
    S6_CW2503_TestA_2111123.REVERSE.EXAM_GROUP_KEY,
    S6_CW2503_TestA_2111123.REVERSE.QR_INFO
  ],
  // 2025-08
  [
    S1_CW2508_TestA_211115.FRONT.EXAM_GROUP_KEY,
    S1_CW2508_TestA_211115.FRONT.QR_INFO
  ],
  [
    S1_CW2508_TestA_211115.REVERSE.EXAM_GROUP_KEY,
    S1_CW2508_TestA_211115.REVERSE.QR_INFO
  ],
  [
    S2_CW2508_TestA_211123.FRONT.EXAM_GROUP_KEY,
    S2_CW2508_TestA_211123.FRONT.QR_INFO
  ],
  [
    S2_CW2508_TestA_211123.REVERSE.EXAM_GROUP_KEY,
    S2_CW2508_TestA_211123.REVERSE.QR_INFO
  ],
  [
    S3_CW2508_TestA_211123.FRONT.EXAM_GROUP_KEY,
    S3_CW2508_TestA_211123.FRONT.QR_INFO
  ],
  [
    S3_CW2508_TestA_211123.REVERSE.EXAM_GROUP_KEY,
    S3_CW2508_TestA_211123.REVERSE.QR_INFO
  ],
  [
    S4_CW2508_TestA_211123.FRONT.EXAM_GROUP_KEY,
    S4_CW2508_TestA_211123.FRONT.QR_INFO
  ],
  [
    S4_CW2508_TestA_211123.REVERSE.EXAM_GROUP_KEY,
    S4_CW2508_TestA_211123.REVERSE.QR_INFO
  ],
  [
    S5_CW2508_TestA_2111123.FRONT.EXAM_GROUP_KEY,
    S5_CW2508_TestA_2111123.FRONT.QR_INFO
  ],
  [
    S5_CW2508_TestA_2111123.REVERSE.EXAM_GROUP_KEY,
    S5_CW2508_TestA_2111123.REVERSE.QR_INFO
  ],
  [
    S6_CW2508_TestA_2111123.FRONT.EXAM_GROUP_KEY,
    S6_CW2508_TestA_2111123.FRONT.QR_INFO
  ],
  [
    S6_CW2508_TestA_2111123.REVERSE.EXAM_GROUP_KEY,
    S6_CW2508_TestA_2111123.REVERSE.QR_INFO
  ],
  // 2026-03
  [
    S1_CW2603_TestA_211115.FRONT.EXAM_GROUP_KEY,
    S1_CW2603_TestA_211115.FRONT.QR_INFO
  ],
  [
    S1_CW2603_TestA_211115.REVERSE.EXAM_GROUP_KEY,
    S1_CW2603_TestA_211115.REVERSE.QR_INFO
  ],
  [
    S2_CW2603_TestA_211123.FRONT.EXAM_GROUP_KEY,
    S2_CW2603_TestA_211123.FRONT.QR_INFO
  ],
  [
    S2_CW2603_TestA_211123.REVERSE.EXAM_GROUP_KEY,
    S2_CW2603_TestA_211123.REVERSE.QR_INFO
  ],
  [
    S3_CW2603_TestA_211123.FRONT.EXAM_GROUP_KEY,
    S3_CW2603_TestA_211123.FRONT.QR_INFO
  ],
  [
    S3_CW2603_TestA_211123.REVERSE.EXAM_GROUP_KEY,
    S3_CW2603_TestA_211123.REVERSE.QR_INFO
  ],
  [
    S4_CW2603_TestA_211123.FRONT.EXAM_GROUP_KEY,
    S4_CW2603_TestA_211123.FRONT.QR_INFO
  ],
  [
    S4_CW2603_TestA_211123.REVERSE.EXAM_GROUP_KEY,
    S4_CW2603_TestA_211123.REVERSE.QR_INFO
  ],
  [
    S5_CW2603_TestA_2111123.FRONT.EXAM_GROUP_KEY,
    S5_CW2603_TestA_2111123.FRONT.QR_INFO
  ],
  [
    S5_CW2603_TestA_2111123.REVERSE.EXAM_GROUP_KEY,
    S5_CW2603_TestA_2111123.REVERSE.QR_INFO
  ],
  [
    S6_CW2603_TestA_2111123.FRONT.EXAM_GROUP_KEY,
    S6_CW2603_TestA_2111123.FRONT.QR_INFO
  ],
  [
    S6_CW2603_TestA_2111123.REVERSE.EXAM_GROUP_KEY,
    S6_CW2603_TestA_2111123.REVERSE.QR_INFO
  ],
])
